/**
 * 尽量锁定竖屏（PWA standalone / 支持 Screen Orientation API 的浏览器）。
 * 浏览器标签页内多数无法强制锁定，需配合 manifest orientation + UI 提示。
 */
export function lockPortraitOrientation() {
  if (typeof window === 'undefined' || typeof screen === 'undefined') return;

  const orient = screen.orientation;
  if (!orient || typeof orient.lock !== 'function') return;

  const tryLock = () => {
    try {
      const p = orient.lock('portrait');
      if (p && typeof p.catch === 'function') {
        p.catch(() => {
          /* 无权限 / 非全屏时浏览器会拒绝，忽略即可 */
        });
      }
    } catch {
      /* ignore */
    }
  };

  tryLock();

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') tryLock();
  });

  // 部分 WebView 需在首次手势后才能 lock
  const onFirstGesture = () => {
    tryLock();
    window.removeEventListener('pointerdown', onFirstGesture, true);
    window.removeEventListener('touchstart', onFirstGesture, true);
  };
  window.addEventListener('pointerdown', onFirstGesture, true);
  window.addEventListener('touchstart', onFirstGesture, true);
}
